import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { orderStatusLabel, panelSx } from "./detailUtils";

export const InfoItem = ({ label, value, strong = false }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography sx={{ fontSize: 12.5, color: "#64748b" }}>{label}</Typography>
    <Typography
      sx={{
        mt: 0.35,
        fontSize: strong ? 18 : 14.5,
        fontWeight: strong ? 800 : 500,
        color: "#111827",
        wordBreak: "keep-all",
      }}
    >
      {value || "-"}
    </Typography>
  </Box>
);

export const MetricCard = ({ label, value, tone = "#6c5ce7", helper }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 1.5,
      borderRadius: "8px",
      borderColor: `${tone}33`,
      bgcolor: "#fff",
      minHeight: 90,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <Typography sx={{ fontSize: 12.5, color: "#64748b" }}>{label}</Typography>
    <Typography sx={{ mt: 0.4, fontSize: 24, lineHeight: 1.1, fontWeight: 900, color: tone }}>
      {value || "-"}
    </Typography>
    {helper && <Typography sx={{ mt: 0.5, fontSize: 12, color: "#64748b" }}>{helper}</Typography>}
  </Paper>
);

export const OssOrderDetailHeader = ({
  order,
  disabledByCancel,
  onBack,
  onEdit,
  onCancel,
  onDelete,
}) => (
  <Paper elevation={0} sx={{ ...panelSx, px: 2, py: 1.45 }}>
    <Stack direction={{ xs: "column", md: "row" }} spacing={1.2} alignItems={{ xs: "stretch", md: "center" }}>
      <Button startIcon={<ArrowBackRoundedIcon />} onClick={onBack} color="inherit" sx={{ alignSelf: { xs: "flex-start", md: "center" } }}>
        목록
      </Button>
      <Box sx={{ minWidth: 0 }}>
        <Typography component="h1" sx={{ fontSize: { xs: 22, md: 26 }, fontWeight: 900, color: "#111827" }}>
          {order.order_no}
        </Typography>
        <Typography sx={{ mt: 0.25, fontSize: 13, color: "#64748b" }}>
          {order.customer_name} · {order.site_name || "납품처 미등록"}
        </Typography>
      </Box>
      <Stack direction="row" spacing={0.8} alignItems="center" sx={{ ml: { md: "auto" }, flexWrap: "wrap" }}>
        <Box
          sx={{
            px: 1.15,
            py: 0.55,
            borderRadius: "999px",
            bgcolor: disabledByCancel ? "#f3f4f6" : "#eef2ff",
            color: disabledByCancel ? "#6b7280" : "#4f46e5",
            fontSize: 12.5,
            fontWeight: 800,
          }}
        >
          {orderStatusLabel[order.order_status] || order.order_status || "-"}
        </Box>
        <Button startIcon={<EditRoundedIcon />} variant="outlined" onClick={onEdit} disabled={disabledByCancel}>
          수정
        </Button>
        <Button variant="outlined" color="warning" onClick={onCancel} disabled={disabledByCancel}>
          취소
        </Button>
        <Button startIcon={<DeleteOutlineRoundedIcon />} variant="outlined" color="error" onClick={onDelete}>
          삭제
        </Button>
      </Stack>
    </Stack>
  </Paper>
);
